import { Box } from "@chakra-ui/react";

export function LeftHandleIcon({ width, height, ...props }: any) {
  return (
    <Box {...props}>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.416667"
          y="0.583323"
          width="15.8333"
          height="15.8333"
          rx="7.91667"
          stroke="#C5C7D0"
          stroke-width="0.833333"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.2948 4.87201C10.4575 5.03473 10.4575 5.29855 10.2948 5.46126L7.35431 8.40176C7.31539 8.44068 7.28385 8.47224 7.257 8.49997C7.28385 8.52769 7.31539 8.55926 7.35431 8.59818L10.2948 11.5387C10.4575 11.7014 10.4575 11.9652 10.2948 12.1279C10.1321 12.2906 9.86827 12.2906 9.70555 12.1279L6.76505 9.18743C6.76056 9.18295 6.75605 9.17844 6.75152 9.17391C6.67091 9.09336 6.58374 9.00627 6.52009 8.92283C6.44551 8.82509 6.36523 8.68523 6.36523 8.49997C6.36523 8.31471 6.44551 8.17485 6.52009 8.07711C6.58374 7.99367 6.67091 7.90658 6.75152 7.82603C6.75605 7.8215 6.76056 7.81699 6.76505 7.8125L9.70555 4.87201C9.86827 4.70929 10.1321 4.70929 10.2948 4.87201Z"
          fill="#18191B"
        />
      </svg>
    </Box>
  );
}
